export const sessions = {
    title: "সেশন",
    description: "যেসব ডিভাইসে আপনি সাইন ইন আছেন। অচেনা কোনো ডিভাইস থেকে সাইন আউট করুন।",
    columns: {
        device: "ডিভাইস",
        method: "সাইন ইনের মাধ্যম",
        signedIn: "সাইন ইন",
        lastActive: "সর্বশেষ সক্রিয়",
    },
    method: { password: "পাসওয়ার্ড", otp: "এসএমএস কোড" },
    unknownDevice: "অজানা ডিভাইস",
    current: "এই ডিভাইস",
    revoke: "সাইন আউট",
    revokeTitle: "এই ডিভাইস থেকে সাইন আউট করবেন?",
    revokeBody: "ওই ডিভাইসে আবার সাইন ইন করতে হবে।",
    revoked: "ডিভাইসটি থেকে সাইন আউট করা হয়েছে।",
    revokeAll: "সব ডিভাইস থেকে সাইন আউট",
    revokeAllTitle: "সব ডিভাইস থেকে সাইন আউট করবেন?",
    revokeAllBody: "এই ডিভাইসসহ সব ডিভাইসে আবার সাইন ইন করতে হবে।",
};
//# sourceMappingURL=sessions.js.map